import './CoralPdpWhatsIncludedWave.scss'

import { useIsWindowBiggerThan } from '@bob/library'
import { CoralMasterCard } from '@coral-library/cards/Coral/ContentCard/CoralMasterCard'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { CoralMasterCardVisuals } from '@websrc/DataMappers/mapCoralMasterCard'
import { mapCoralWebPdpWhatSIncludedWave } from '@websrc/DataMappers/mapSpot'
import React, { FC, useMemo } from 'react'

type CoralPdpWhatsIncludedWaveProps = ReturnType<typeof mapCoralWebPdpWhatSIncludedWave>

const smVisualsWhatsIncluded: CoralMasterCardVisuals = {
  headlineSize: 'h2-sm',
  contentContainerColor: 'off-white',
  contentPadding: '3xl',
  bodySize: 'body-sm',
  paddingBody: '2xl',
  imageOrientation: 'top',
  imageAbsolute: false,
  equalSize: true,
  imageRatio: '1-1',
  positionButton: 'start',
  paddingHeadline: 'lg',
  radius: 4,
  positionContent: 'center',
}

const lgVisualsWhatsIncluded: CoralMasterCardVisuals = {
  cardSize: 720,
  headlineSize: 'h2-sm',
  contentContainerColor: 'off-white',
  contentPadding: '4xl',
  bodySize: 'body-sm',
  paddingBody: '2xl',
  imageOrientation: 'left',
  imageAbsolute: true,
  imageRatio: '1-1',
  positionButton: 'start',
  radius: 4,
  positionContent: 'center',
}

const smVisualsAI: CoralMasterCardVisuals = {
  headlineSize: 'h3-sm',
  contentContainerColor: 'off-white',
  contentPadding: '3xl',
  bodySize: 'label-sm-regular',
  paddingBody: '2xl',
  imageOrientation: 'top',
  imageAbsolute: false,
  equalSize: true,
  imageRatio: '1-1',
  buttonWidth: 'auto',
  paddingHeadline: 'lg',
  paddingList: 'lg',
  radius: 4,
  radiusBadge: 4,
  positionContent: 'center',
}

const mdVisualsAI: CoralMasterCardVisuals = {
  headlineSize: 'h3-md',
  contentContainerColor: 'off-white',
  contentPadding: '4xl',
  bodySize: 'body-md',
  paddingBody: '2xl',
  imageOrientation: 'top',
  imageAbsolute: false,
  equalSize: true,
  imageRatio: '1-1',
  buttonWidth: 'auto',
  paddingHeadline: 'lg',
  paddingList: 'lg',
  radius: 4,
  radiusBadge: 4,
  positionContent: 'center',
}

const lgVisualsAI: CoralMasterCardVisuals = {
  cardSize: 720,
  headlineSize: 'h3-md',
  contentContainerColor: 'off-white',
  contentPadding: '4xl',
  bodySize: 'body-md',
  paddingBody: '2xl',
  imageOrientation: 'left',
  imageAbsolute: true,
  imageRatio: '1-1',
  equalSize: true,
  buttonWidth: 'auto',
  paddingHeadline: 'lg',
  paddingList: 'lg',
  radius: 4,
  radiusBadge: 4,
  positionContent: 'center',
}
export const CoralPdpWhatsIncludedWave: FC<CoralPdpWhatsIncludedWaveProps> = (props) => {
  const isDesktop = useIsWindowBiggerThan(1079)
  const isTablet = useIsWindowBiggerThan(719)
  const visualsWhatsIncludedCard = useMemo(
    () => (isDesktop ? lgVisualsWhatsIncluded : smVisualsWhatsIncluded),
    [isDesktop]
  )
  const visualsAICard = useMemo(
    () => (isDesktop ? lgVisualsAI : isTablet ? mdVisualsAI : smVisualsAI),
    [isDesktop, isTablet]
  )
  props.safeAICard.badges[0].color = 'blue-pale'
  return (
    <div className={'container-coral-spot'}>
      <div className={'pdp-whats-included-wave'}>
        <CoralHeading
          animate={false}
          header={props.header}
          headerTag={'h1'}
          headerVisual={'h1-md'}
        />
        <CoralMasterCard visuals={visualsWhatsIncludedCard} {...props.whatsIncludedCard} />
        <CoralMasterCard visuals={visualsAICard} {...props.safeAICard} />
      </div>
    </div>
  )
}
